import { defineMessages } from 'react-intl';

export default defineMessages({
	emptyStateDescription: {
		defaultMessage:
			'All your topics are hidden or none have been created yet. Select Topics and portals from the avatar menu to create and manage topics.',
		description: 'Description message for topics empty state',
		id: 'hc.customization.list-of-topics.empty-state-description',
	},
	emptyStateTopicsDescription: {
		defaultMessage:
			'All your topics are hidden or none have been created. Select <b>Customize,</b> then <b>Manage topics and portals</b> from the navigation to create and manage topics.',
		description: 'Description message for topics empty state',
		id: 'hc.customization.list-of-topics.empty-state-topics-description',
	},
});
